import {ArticleReference} from './ArticleReference';
export default ArticleReference;
